import C from "../constants/constants";
import Http from "../services/http.service.ts";

/**
 * API methods for interacting with `/nylas/*` endpoint.
 */
const NylasApi = {};

NylasApi.generateAuthUrl = async (email, successUrl) =>
  (await Http.get().post(`${C.VITE_APP_NEST_SERVER}/v2/users/nylas-generate-auth-url`, { email, successUrl })).data;
NylasApi.exchangeMailboxToken = async (token) =>
  (await Http.get().post(`${C.VITE_APP_NEST_SERVER}/v2/users/nylas-exchange-mailbox-token`, { token })).data;

export default NylasApi;
